'use client'

import * as React from 'react'
import { useTranslations } from 'next-intl'
import { useQueryClient } from '@tanstack/react-query'

import { useDesignerRequest } from '../_requests/designer-request'
import { ModalWithError } from '@web/components/prod/modal-with-error'
import { useModalContext } from '../_context/modal-context'
import { GetDesignerVerificationStatusQueryKey } from '@web/gen/user'
import { StoreApplicationForm } from './store-application-form'
import { SubmissionConfirmation } from './submission-confirmation'

export const OpenAStoreModal = () => {
  const { closeOpenStoreModal } = useModalContext()
  const [isSubmitted, setIsSubmitted] = React.useState(false)
  const queryClient = useQueryClient()
  const t = useTranslations('my_account.open_store_modal')
  const translateFn = (key: string) => t(key.split('.').pop() || '')

  const designerRequestMutation = useDesignerRequest(translateFn)

  React.useEffect(() => {
    if (designerRequestMutation.isSuccess) {
      setIsSubmitted(true)
      queryClient.invalidateQueries({ queryKey: GetDesignerVerificationStatusQueryKey() })
    }
  }, [designerRequestMutation.isSuccess, queryClient])

  const errorMessage = designerRequestMutation.error ? t('errors.submission_failed') : null

  return (
    <ModalWithError isOpen={true} onClose={closeOpenStoreModal} error={errorMessage}>
      <div className="p-6">
        {!isSubmitted ? (
          <StoreApplicationForm
            onSubmit={values => designerRequestMutation.mutate(values)}
            isPending={designerRequestMutation.isPending}
          />
        ) : (
          <SubmissionConfirmation
            onClose={closeOpenStoreModal}
            isPending={designerRequestMutation.isPending}
          />
        )}
      </div>
    </ModalWithError>
  )
}
